import { render, staticRenderFns } from "./examinee.vue?vue&type=template&id=70ce9743&scoped=true&"
import script from "./examinee.vue?vue&type=script&lang=js&"
export * from "./examinee.vue?vue&type=script&lang=js&"
import style0 from "./examinee.vue?vue&type=style&index=0&id=70ce9743&lang=less&scoped=true&"
import style1 from "./examinee.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce9743",
  null
  
)

export default component.exports